/**
 * Generic Storage Service
 * Wraps localStorage to provide a consistent API and handle serialization errors.
 */

export const storage = {
    get: <T>(key: string, defaultValue: T): T => {
        try {
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item) : defaultValue;
        } catch (error) {
            console.error(`Error reading key "${key}" from localStorage:`, error);
            return defaultValue;
        }
    },

    set: <T>(key: string, value: T): void => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error(`Error writing key "${key}" to localStorage:`, error);
            throw error; // Re-throw to let caller handle it (e.g. QuotaExceededError)
        }
    },

    remove: (key: string): void => {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error(`Error removing key "${key}" from localStorage:`, error);
        }
    },

    // Simulate async network delay for "production feel"
    delay: (ms: number = 500) => new Promise(resolve => setTimeout(resolve, ms))
};
